import { sanitizeHtml } from '@main/utils';
import React from 'react';
import sanitizeHtmlLib from 'sanitize-html';

import { ImageSizeContainer } from './wrappers';

/**
 * Props for the sanitize html component
 */
export interface SanitizeHtmlProps
  extends Omit<
    React.HTMLAttributes<HTMLSpanElement & HTMLDivElement>,
    'dangerouslySetInnerHTML'
  > {
  /** The HTML to render */
  html: string;
  /** Use a span instead of a div */
  span?: boolean;
  /** Options for sanitizing */
  options?: sanitizeHtmlLib.IOptions;
  /** whether to shrink images */
  shrinkImages?: boolean;
}

/**
 * Render sanitized HTML to avoid using dangerouslySetInnerHTML
 */
export function SanitizeHtml({
  html,
  span,
  options,
  shrinkImages,
  ...rest
}: SanitizeHtmlProps): JSX.Element {
  if (span) {
    return (
      <span
        {...(rest as any)}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(html, options),
        }}
      />
    );
  }
  return shrinkImages ? (
    <ImageSizeContainer
      {...rest}
      dangerouslySetInnerHTML={{
        __html: sanitizeHtml(html, options),
      }}
    />
  ) : (
    <div
      {...rest}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: sanitizeHtml(html, options),
      }}
    />
  );
}
